module.exports = __webpack_public_path__ + "img/Russia.a456fbcf.jpg";